<template>
  <Layout>
    <div class="banner-page">
      <img src="img/covid-banner.png" alt="Image" />
    </div>

    <div class="breadcrumbs">
      <div class="container">
        <ul>
          <li>
            <a href="/">Beranda</a>
          </li>
          <li>
            <span>Pendaftaran Lembaga</span>
          </li>
        </ul>
      </div>
    </div>

    <section class="page-section covid-section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-8 registration-wrapper">
            <img class="icon-image" src="/img/success.svg" alt="success" />
            <h5>Pendaftaran Berhasil</h5>
            <p>
              Silahkan cek email untuk mengaktifasi <br />akun
              <strong>masjed.id</strong> anda.
            </p>
            <br />
            <a href="/" class="btn btn-cta btn-full">Kembali</a>
          </div>
        </div>
      </div>
    </section>
  </Layout>
</template>

<script>
import Layout from '../../views/layouts/Index.vue';

import { mapActions } from 'vuex';

export default {
  components: {
    Layout,
  },
  methods: {
    ...mapActions('transactions', ['resetForm']),
  },
  mounted() {
    this.resetForm();
  },
};
</script>

<style lang="scss" scoped>
ol {
  li {
    margin-bottom: 5px;
  }
}
ol.nonumber {
  list-style-type: none;
  li {
    margin-bottom: 0px !important;
  }
}

.icon-image {
  height: 180px;
}

.registration-wrapper {
  text-align: center;
  padding: 40px 0px;

  h5 {
    font-size: 25px;
    font-weight: bold;
    color: rgb(24, 92, 24);
  }

  img,
  h5,
  p {
    margin-bottom: 20px;
  }

  p {
    color: #444;
  }
}
</style>
